import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";

const Data = [
  // {
  //   id: 1,
  //   name: 'Overall Summary',
  //   icon: 'images/summary.png',
  //   backgroundColor: '#F5C621',
  //   tintColor: null,
  //   navigation: '/OverallSummary',
  // },
  {
    id: 3,
    name: 'Overall Revenue',
    icon: 'Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif',
    backgroundColor: '#1F78D9',
    tintColor: null,
    navigation: '/OverallRevenue',
  },
  {
    id: 4,
    name: 'Top Performer',
    icon: 'images/money.png',
    backgroundColor: '#AD39BF',
    tintColor: null,
    navigation: '/TopPerformer',
  },

  // {
  //   id: 3,
  //   name: 'Top Services',
  //   icon: 'Laundy_App_Icons_Gifs/SettingIcons/discount.png',
  //   backgroundColor: '#E63F52',
  //   tintColor: '#fff',
  //   navigation: '/TopServices',
  // },
  // {
  //   id: 4,
  //   name: 'Top Garments',
  //   icon: 'images/garments.png',
  //   backgroundColor: '#F5C621',
  //   tintColor: null,
  //   navigation: '/TopGarments',
  // },
  {
    id: 5,
    name: 'Top Services',
    icon: 'Laundy_App_Icons_Gifs/SettingIcons/discount.png',
    backgroundColor: '#E63F52',
    tintColor: '#fff',
    navigation: '/TopServices',
  },
  {
    id: 6,
    name: 'Top Garments',
    icon: 'images/garments.png',
    backgroundColor: '#F5C621',
    tintColor: null,
    navigation: '/TopGarments',
  },
  {
    id: 7,
    name: 'Process Status',
    icon: 'images/graph.png',
    backgroundColor: '#43BFC7',
    tintColor: null,
    navigation: '/ProcessStatus',
  },
];
const AnalyticsList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  const brandOfferModal = brandProfileData.brandOffModel;
  const enabledPaymentGateway = brandProfileData.enabledPaymentGateway;

  const filteredData = Data.filter(item =>  brandOfferModal || item.id !== 6).filter((item) => enabledPaymentGateway || item.id !== 8)

  const renderCardItem = () => {
    return filteredData?.map((item, index) => {
      if (userRole === "BY_RIDER" && item.name === "Store User") {
        return null;
      }
      if (userRole === "BY_FRANCHISE_ADMIN" && item.id === 5) return null;
      if (userRole === "BY_FRANCHISE_ADMIN" && item.id === 6) return null;
      return (
        <div
           onClick={() =>
                    navigate(item.navigation, {
                      state: {
                        id: id,
                      },
                    })
                  }
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
              alt="icon"
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">Analytics</p>
            </div>
          </div>

           

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-3">
          {filteredData?.length ? (
          renderCardItem()
        ) : (
          <p>No card data available.</p>
        )}

        <div className="flex justify-content-center">
          <img
            src={"VectorsLaundryApp/4.png"}
            style={{
              alignSelf: "center",
            }}
            alt="icon"
          />
        </div>
         
      </div>
       
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default AnalyticsList;
